import React from "react";
import Menu from "../components/grids/static/menu/menu";
import Footer from "../components/grids/static/footer/footer";
import HeaderVideo from "../components/grids/static/header/headerVideo";
import QuotePhoto from "../components/grids/quotes/quotePhoto";
import Logos from "../components/grids/photo/logos";
import AllPosts from '../components/grids/specifique/posts'
import Produits from "../components/grids/specifique/gridTextProduits";
import QuoteFull from "../components/grids/quotes/quoteFull";
import NapsisTeamPhoto from "../components/grids/photo/napsisTeamPhoto";
import GridTextArgs from "../components/grids/blocks/gridText-4";
import { SeoMetaPage } from "../components/seo/seoMetaPage";
import Positionnement from "../components/grids/specifique/gridTextAnimation";
import Datas from '../content/home.yaml'
import { graphql } from "gatsby"


export default function IndexPage({ data }) {
  const contenu = Datas.content
  return (
    <>
      <Menu
        type='left'
      />
      <HeaderVideo
        content={contenu.header}
      />
      <main>
        <QuotePhoto
          lineStep='2'
          content={contenu.quote}
          pics={data.allFile}
          dividerColor
        />
        <Positionnement
          content={contenu.animation}
        />
        <Produits
          lineStep='3'
          content={contenu.products}
          pics={data.allFile}
        />
        <QuoteFull
          lineStep='4'
          content={contenu.quoteExpert}
          pics={data.allFile}
        />
        <NapsisTeamPhoto
          content={contenu.team}
          colorBckgd='noir-bckd'
        />
        <Logos
          content={contenu.logos}
          type='clients'
          pics={data.allFile}
        />
        <AllPosts
          data={data}
          button
        />
        <GridTextArgs
          content={contenu.big}
          lineStep='14'
          margin="10"
        />
        <Footer
          content={data.allWpPost}
          type='page'
        />
      </main>
    </>
  )
}

export const query = graphql`{
  allWpPost(limit: 7) {
    edges {
      node {
        seo {
          metaDesc
        }
      }
    }
    nodes {
      title
      uri
      featuredImage {
        node {
          mediaItemUrl
          gatsbyImage(width: 500)
        }
      }
    }
  }
  allWpPage(filter: {slug: {eq: "une-autre-vision-des-telecoms"}}) {
    edges {
      node {
        seo {
          title
          metaDesc
          canonical
          opengraphImage {
            mediaItemUrl
          }
          schema {
            articleType
            pageType
            raw
          }
          opengraphUrl
          opengraphType
          opengraphTitle
          opengraphSiteName
          opengraphPublisher
          opengraphPublishedTime
          opengraphModifiedTime
          opengraphDescription
          metaRobotsNoindex
          metaRobotsNofollow
          metaKeywords
          opengraphType
          breadcrumbs {
            text
            url
          }
        }
      }
    }
  }
  allFile(
    filter: {name: {in: ["guillaume", "centrex-icon-bleu", "mobile-icon-bleu", "message-icon-bleu", "sd-wan-icon", "casque-icon-bleu", "routeur-icon", "vpn-icon", "securite-icon", "nuage-icon-violet", "michel-macaron", "arthus", "babilou", "bioclinic", "cer", "face", "hyundai", "tao", "ballon"]}}
  ) {
    edges {
      node {
        id
        base
        name
        childImageSharp {
          gatsbyImageData(layout:CONSTRAINED)
        }
      }
    }
  }
}`

export function Head({ data }) {
  return (
    <SeoMetaPage
      datas={data.allWpPage}
    />
  )
}  